<template>
	<div class="banner-split2-reservation-secret">
		<b-row class="banner">
			<b-col class="col-lg-6 col-sm-12 col-12 left banner-item">
				<Slider :data="sliderData"></Slider>
			</b-col>
			<b-col class="col-lg-6 col-sm-12 col-12 right banner-item">
				<h3 class="title"> 穀倉改造 偶村限定 村民日常 與偶同樂</h3>
				<br><br>
				<p class="content">
					「利澤國際偶戲藝術村」由舊穀倉改建為現有之藝術空間，擁有藝享基地、大排練場、木工廠、製偶教室、以及小型展演廳等藝術空間，為極具國際水準的現代偶戲創作基地。歡迎加入偶們「偶戲村大解密」的行列，一同窺探偶戲村村民的日常生活，探索由古老舊穀倉大改造的偶戲藝術村。
					<br><br> 每週六、日的11:00和15:00。
					<br> 時間：約50-60分鐘。
					<br> 參加方式：現場報名，每場最多20人，每人200元，12歲以下150元，3歲以下免費。
					<br> ※若為20人以上團體參訪，建議預約
					<router-link to="/reservation/play" tag="span" class="apply-btn">偶在穀倉玩</router-link> ，或來電詢問03-950-1977張小姐。
				</p>
				<br><br>
				<p class="content">
					The Lize Puppet Art Colony is an art space that made up of barns, which have been renovated as an art and exploration spaces. With the main building, rehearsal hall, woodshop, craft room, and performance studio, the colony becomes an international and professional foundation of the contemporary puppetry. We welcome you to explore the area and engage with our staff and artists in their daily life here through our guided tours.
					<br>
					<br> Time: 11:00 & 15:00 on Saturday & Sunday
					<br> Duration: 50-60 min.
					<br> Fee:
					<br> * NT$200/person
					<br> * NT$150/person (children under the age of 12)
					<br> * Free (kid under the age of 3)
					<br> ※ Visit Colonyors above 20 people are suggested to reserve the Visit Colony in advance.
					<router-link to="/reservation/play" tag="span" class="apply-btn">Visit Colony</router-link> or contact our officer (+886-3-9501977) in advance.
				</p>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import Slider from '@/components/slider'
export default {
	name: "bannerSplit2ReservationSecret",
	data() {
		return {
			sliderData: [
				"/static/assets/reservation/secret/img_01.jpg",
			]
		};
	},
	props: {
		ch: String,
		en: String
	},
	components: {
		Slider
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .banner-split2-reservation-secret
    overflow: hidden
    .banner
      text-align: justify
      .banner-item
        min-height: 480px
        height: 471px
        @media screen and (max-width: 1000px)
          height: initial
          min-height: 300px
      .left
        padding: 0
      .right
        background-color: $themeGray
        color: $white
        padding: 45px
        overflow-y: auto
        font-weight: 300
        .title
          font-size: $font-size-3
          margin: 20px 0
        .content
          font-size: $font-size-3-s
          line-height: 2
          .apply-btn
            font-size: 14px
            padding: 1px 8px
            border-radius: 100px
            background-color: #01b6e2
            cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/banner/banner_split2_reservation_secret.vue